import hoc, { IconProps } from 'bloko/blocks/icon/hoc';

const FacebookScaleMediumAppearanceOutlined = hoc(
    (props: IconProps) => (
        <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M8.92309 22.1538C8.92309 22.43 9.14694 22.6538 9.42309 22.6538H13.0385C13.3146 22.6538 13.5385 22.43 13.5385 22.1538V13.5709H15.8462C16.0978 13.5709 16.3102 13.3839 16.3421 13.1343L16.8037 9.52493C16.8219 9.38243 16.7779 9.23898 16.683 9.13114C16.5881 9.02331 16.4514 8.96151 16.3077 8.96151H13.5385V6.96272C13.5385 6.42389 13.6365 6.13812 13.7382 6.00396C13.8521 5.86649 14.1317 5.71752 14.7692 5.71752H16.6154C16.8915 5.71752 17.1154 5.49367 17.1154 5.21752V2.00478C17.1154 1.7578 16.9351 1.54782 16.6909 1.51052C15.9637 1.39941 15.0383 1.34613 13.9231 1.34613C12.4538 1.34613 11.2275 1.80075 10.2977 2.74464C9.36051 3.69597 8.92309 5.00682 8.92309 6.60575V8.96151H6.46155C6.18541 8.96151 5.96155 9.18537 5.96155 9.46151V13.0709C5.96155 13.347 6.18541 13.5709 6.46155 13.5709H8.92309V22.1538Z"
                stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    'Facebook'
);
export default FacebookScaleMediumAppearanceOutlined;
